import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Navbar from "../Navbar";
import Abuotus from "../components/Abuotus";
import Cart from "../components/Cart";
import Contact from "../components/Contact";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import Guide from "../components/Guide";
import Home from "../components/Home";
import BlogList from "../components/Blog/BlogList";
import BlogDetail from "../components/Blog/BlogDetail";
// import PageRouter from "../components/Page/PageRouter"; // Component doesn't exist
import PageList from "../components/PageList";
import ReturnPolicy from "../components/ReturnPolicy";
import ShippingInfo from "../components/ShippingInfo";
import InstallationCostEstimation from "../components/Installation/InstallationCostEstimation";
import OrderDetails from "../components/MyProfile/Order/OrderDetails";
import Profile from "../components/MyProfile/Profile";
import Privacy from "../components/Privacy";
import Terms from "../components/Terms";
import Testimonials from "../components/Testimonials";
import Brand from "../components/flooring/Brand";
import BrandProductPage from "../components/flooring/BrandProductPage";
import CostEstimation from "../components/flooring/CostEstimation";
import Favorite from "../components/flooring/Favorite";
import NewQuoteSummary from "../components/flooring/NewQuoteSummary";
import NoProductPage from "../components/flooring/NoProductPage";
import NoQuoteSummary from "../components/flooring/NoQuoteSummary";
import Product from "../components/flooring/Product";
import ProductDetail from "../components/flooring/ProductDetail";
import QuoteFinal from "../components/flooring/QuoteFinal";
import SavedInstallation from "../components/flooring/SavedInstallation";
import ThankYou from "../components/flooring/ThankYou";
import ContactUs from "../components/flooring/extraInfoPages/ContactUs";
import GetSamples from "../components/flooring/extraInfoPages/GetSamples";
import SampleInfo from "../components/flooring/extraInfoPages/SampleInfo";
import CheckoutContact from "../components/forCheckoutAndPayment/CheckoutContact";
import PaymentCancel from "../components/forCheckoutAndPayment/PaymentCancel";
import PaymentSuccess from "../components/forCheckoutAndPayment/PaymentSuccess";
import { fetchCartItems } from "../store/slices/Cart";
import { getFev } from "../store/slices/FavSlices";
import Sitemap from "../components/Sitemap";
import CollectionProductPage from "../components/flooring/CollectionProductPage";
import CatchAllRoute from "../components/CatchAllRoute";


function LayoutRoutes() {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  useEffect(() => {
    if (userData) {
      dispatch(fetchCartItems(userData?.user?.email));
      dispatch(getFev());
    }
  }, [userData, dispatch]);
  return (
    <>
      <Navbar />
      <div className="app-container">
        <div className="main-content">
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/about" element={<Abuotus />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/vinylwood" element={<Product />} />
            <Route exact path="/category/:slug" element={<Product />} />
            <Route exact path="/collection/:slug" element={<CollectionProductPage />} />
            <Route exact path="/faq" element={<Faq />} />
            <Route exact path="/brand" element={<Brand />} />
            <Route exact path="/favorite" element={<Favorite />} />
            <Route
              exact
              path="/costestimationInstallationPage"
              element={<InstallationCostEstimation />}
            />
            <Route exact path="/costestimation" element={<CostEstimation />} />
            <Route exact path="/cart" element={<Cart />} />
            <Route exact path="/cart/:email" element={<Cart />} />
            <Route
              exact
              path="/newQuoteSummary"
              element={<NewQuoteSummary />}
            />
            <Route exact path="/productdetail" element={<ProductDetail />} />
            <Route exact path="/QueatNumber" element={<QuoteFinal />} />
            <Route exact path="/Installation" element={<ThankYou />} />
            <Route exact path="/sampleInfo" element={<SampleInfo />} />
            <Route
              exact
              path="/SavedInstallation/:id"
              element={<SavedInstallation />}
            />
            <Route exact path="/brand/:slug" element={<BrandProductPage />} />
            <Route exact path="/testimonials" element={<Testimonials />} />
            <Route exact path="/privacy" element={<Privacy />} />
            <Route exact path="/terms" element={<Terms />} />
            <Route exact path="/return-policy" element={<ReturnPolicy />} />
           
            <Route exact path="/guide" element={<Guide />} />
            <Route exact path="/NoCard" element={<NoQuoteSummary />} />
            <Route exact path="/NoProduct" element={<NoProductPage />} />
          
            <Route exact path="/profile" element={<Profile />} />
            <Route exact path="/profile/:id" element={<Profile />} />
            <Route exact path="/Checkout" element={<CheckoutContact />} />
            <Route exact path="/success" element={<PaymentSuccess />} />
            <Route exact path="/cancel" element={<PaymentCancel />} />
            {/* <Route
              exact
              path="/clearencePage"
              element={<ClearenceProductPage />}
            /> */}
            {/* <Route
              exact
              path="/MonthSpecialPage"
              element={<MonthSpecialProductPage />}
            /> */}
            <Route exact path="/contactUs" element={<ContactUs />} />
            <Route exact path="/getsamples" element={<GetSamples />} />
            <Route exact path="/orderdetail" element={<OrderDetails />} />
            <Route exact path="/shipping-info" element={<ShippingInfo />} />

            {/* Blog Routes */}
            <Route exact path="/blogs" element={<BlogList />} />
            <Route exact path="/blog/:slug" element={<BlogDetail />} />

            {/* Page Builder Routes */}
            <Route exact path="/pages" element={<PageList />} />

            {/* Page Routes - This should be one of the last routes to avoid conflicts */}
            {/* <Route exact path="/:slug" element={<PageRouter />} /> */}
            
            {/* Collection-based product detail route - Place near the end to avoid conflicts */}
            <Route
              exact
              path="/:collectionSlug/:productSlug"
              element={<ProductDetail />}
            />
            
            <Route exact path="/:slug" element={<CatchAllRoute />} />

            {/* Redirect testing route removed for production */}

            {}
            {/* CatchAllRoute handles unknown routes with redirect checking */}
            {/* <Route path="*" element={<CatchAllRoute />} /> */}
            {/* <Route exact path="/sitemap" element={<Sitemap />} /> */}
          </Routes>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default LayoutRoutes;
